import React, { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { useLocation, useNavigate } from "react-router-dom";
import { SemesterContext } from "../context/SemesterContext";
import MinimalSelect from "./MinimalSelect";
import { LocationInterface } from "./UtilsComponents";

interface StudentProps {
  onSemesterChange: any;
  setSelectedSemester: any;
  selectedSemeseter: any;
}
const StudentYearSelector = (props: StudentProps) => {
  const { onSemesterChange, selectedSemeseter, setSelectedSemester } = props;
  let location = useLocation() as LocationInterface;
  const screenClass = useScreenClass();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const semesterContext = useContext(SemesterContext);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  useEffect(() => {
    const allSemesters = [{ label: "All", value: "", year: "" }];
    setIsDisabled(false);
    if (
      !semesterContext.semesters.some(
        (elem) => elem.label === allSemesters[0].label
      )
    ) {
      semesterContext.setAllSemester(
        allSemesters.concat(semesterContext.semesters)
      );
    }
    setSelectedSemester({ label: "All", value: "", year: "" })
  }, [semesterContext]);
  return (
    <>
      {semesterContext.semesters.length > 0 &&
        semesterContext.selectedSemester?.label !== "" && (
          <MinimalSelect
            isDisabled={isDisabled}
            setClass={isMobile ? "rs-container" : ""}
            placeholder="Select Semester"
            options={semesterContext.semesters}
            value={
              selectedSemeseter
            }
            onChange={(data) => {
              onSemesterChange(data);
            }}
          ></MinimalSelect>
        )}
    </>
  );
};

export default StudentYearSelector;
